const AiRoutePlannerIcon = () => {
  return (
    <svg
      className="MuiSvgIcon-root"
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
    >
      <g clipPath="url(#a)">
        <g clipPath="url(#b)">
          <path d="M8.077 10.94c0 .93-.842 1.682-1.88 1.682-1.039 0-1.88-.753-1.88-1.682 0-.929.841-1.682 1.88-1.682 1.038 0 1.88.753 1.88 1.682ZM17.475 19.352c0 .93-.841 1.683-1.88 1.683-1.038 0-1.88-.754-1.88-1.683s.842-1.682 1.88-1.682c1.039 0 1.88.753 1.88 1.682ZM11.835 12.202c0-.697.631-1.262 1.41-1.262.779 0 1.41.565 1.41 1.262v3.785h1.88v-3.785c0-1.626-1.473-2.944-3.29-2.944s-3.29 1.318-3.29 2.944v5.888c0 .697-.632 1.262-1.41 1.262-.78 0-1.41-.565-1.41-1.262v-3.785H5.253v3.785c0 1.626 1.473 2.944 3.29 2.944s3.29-1.318 3.29-2.944v-5.888Z" />
        </g>
      </g>
      <path d="m18.5 7.5-2 .75 2 .75.75 2L20 9l2-.75-2-.75-.75-2-.75 2Zm-4-4-2.5 1 2.5 1 1 2.5 1-2.5 2.5-1-2.5-1-1-2.5-1 2.5Z" />
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M1 7h19v17H1z" />
        </clipPath>
        <clipPath id="b">
          <path fill="#fff" d="M3.375 8.417h15.042v13.458H3.375z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AiRoutePlannerIcon;
